import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import ServiceTypes from './ServiceTypes';
import Pricing from './Pricing';
import AddOns from './AddOns';
import StoragePricing from './StoragePricing';
import WarehouseAddress from './WarehouseAddress';
import Requests from './Requests';
import PickupCodes from './PickupCodes';

const Fulfillment = () => {
  const location = useLocation();
  
  // Determine which component to render based on the current path
  const renderPage = () => {
    const path = location.pathname;
    
    if (path.includes('/pricing')) {
      return <Pricing />;
    } else if (path.includes('/addons')) {
      return <AddOns />;
    } else if (path.includes('/storage')) {
      return <StoragePricing />;
    } else if (path.includes('/warehouse-address')) {
      return <WarehouseAddress />;
    } else if (path.includes('/pickup-codes')) {
      return <PickupCodes />;
    } else if (path.includes('/requests')) {
      return <Requests />;
    } else {
      // Default to ServiceTypes for /service-types or root
      return <ServiceTypes />;
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh',
      backgroundColor: 'background.default',
      p: { xs: 1, sm: 2, md: 3 }
    }}>
      {renderPage()}
    </Box>
  );
};

export default Fulfillment;

